var spinner;

if (typeof getSpinner === "function") {
    spinner = getSpinner();
}

var ordertitlerows = document.querySelectorAll('.js-order-title');

for (var i = 0; i < ordertitlerows.length; i++) {
    ordertitlerows[i].onclick = toggleDetails;
}

var loadMoreButton = document.querySelectorAll('#loadMoreButton');
if (loadMoreButton && loadMoreButton[0]) {
    loadMoreButton[0].onclick = loadMore;
}

function initApproveBtns() {
    var approveBtns = document.querySelectorAll('.jsApproveOrder');
    for (var i = 0; i < approveBtns.length; i++) {
        approveBtns[i].onclick = approveOrder;
    }
}

function initApproveBtnsNew() {
    var approveBtns = document.querySelectorAll('.jsApproveOrderNew');
    for (var i = 0; i < approveBtns.length; i++) {
        approveBtns[i].onclick = approveOrderNew;
    }
}

function initDeclineBtns() {
    var declineBtns = document.querySelectorAll('.jsDeclineOrder');
    for (var i = 0; i < declineBtns.length; i++) {
        declineBtns[i].onclick = declineOrder;
    }
}

function initDeclineBtnsNew() {
    var declineBtns = document.querySelectorAll('.jsDeclineOrderNew');
    for (var i = 0; i < declineBtns.length; i++) {
        declineBtns[i].onclick = declineOrderNew;
    }
}

function initDownloadBtn() {
    if (document.querySelectorAll('.jsDownloadOrder').length > 0) {
        document.querySelectorAll('.jsDownloadOrder')[0].onclick = downloadOrders;
    }
}

$(document).ready(function () {

    initApproveBtnsNew();
    initDeclineBtnsNew();
    initDownloadBtn();
})

function downloadOrders(event) {

    event.preventDefault();

    var el = this;
    var form = el.closest("form");

    var exportWarning = el.getAttribute("data-export-warning");

    if (!confirm(exportWarning)) {
        return;
    }

    //var loader = document.getElementById("loader");
    //loader.style.display = "block";
    el.disabled = true;

    var searchTerm = document.getElementById("searchTerm").value;

    var dropDown = document.getElementById("selectedStateFilter");
    var selectedStateFilter = dropDown?.options[dropDown?.selectedIndex].value;

    var parms = '';
    if (selectedStateFilter != undefined && selectedStateFilter !== '') {
        parms = "?selectedStateFilter=" + selectedStateFilter;
    }
    if (selectedStateFilter != undefined && searchTerm !== '') {
        if (parms == '') {
            parms += "?searchTerm=" + searchTerm;
        }
        else {
            parms += "&searchTerm=" + searchTerm;
        }
    }

    var downloadIFrame = document.getElementById("download_frame");

    downloadIFrame.src = form.action + "download" + parms;

    //loader.style.display = "none";
}

function declineOrder(event) {
    event.preventDefault();

    var el = this;

    var form = el.closest("form");
    var number = el.getAttribute('data-order-number');
    var language = el.getAttribute('data-language');
    var securityString = el.getAttribute('data-securitystring');

    var data = {
        orderNumber: number,
        language: language,
        securityString: securityString
    };

    fetch(form.action, {
        method: 'POST',
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(data)
    })
        .then(function (result) {
            return result.text();
        })
        .then(function (html) {
            // Show new details.. 
            var target = document.querySelector("#order-details-" + number);

            target.innerHTML = html;
            target.style.display = "table-cell";

            var orderStatus = document.querySelector("#order-status-" + number);

            var statusCancelled = orderStatus.getAttribute('data-status-cancelled');

            orderStatus.innerHTML = statusCancelled;

            initApproveBtns();
            initApproveBtnsNew();
            initDeclineBtns();
            initDeclineBtnsNew();
            initDownloadBtn();
        })
        .catch(function (err) {
            console.log(err);
        });
}

function declineOrderNew(event) {
    event.preventDefault();

    var el = this;

    var form = el.closest("form");
    var number = el.getAttribute('data-order-number');
    var language = el.getAttribute('data-language');
    var securityString = el.getAttribute('data-securitystring');

    var data = {
        orderNumber: number,
        language: language,
        securityString: securityString
    };

    fetch(form.action, {
        method: 'POST',
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(data)
    })
        .then(function (result) {
            if (result.status != 200) {
                // TODO Error notice?
            } else {
                hideApproveButtons(number);
                hideDeclineButtons(number);

                var orderStatuses = document.getElementById("orderStatuses");

                // Set the Order Status
                var statusCancelled = orderStatuses.dataset.statusCancelled;

                var orderStatusLabels = document.querySelectorAll(".order-status-" + number);

                for (var i = 0; i < orderStatusLabels.length; i++) {
                    orderStatusLabels[i].innerHTML = "<strong>" + statusCancelled + "</strong>";
                }

                // Set the Order Icon
                var iconSvgRef = orderStatuses.dataset.iconSvgRef;

                var iconStatusCancelled = orderStatuses.dataset.iconStatusCancelled;

                var orderStatusIcons = document.querySelectorAll(".js-icon-status-" + number);

                for (var i = 0; i < orderStatusIcons.length; i++) {
                    var titleElement = orderStatusIcons[i].getElementsByTagName("title")[0];

                    titleElement.textContent = statusCancelled;

                    var useElement = orderStatusIcons[i].getElementsByTagName("use")[0];

                    useElement.setAttributeNS("http://www.w3.org/1999/xlink", 'xlink:href', iconSvgRef + "#" + iconStatusCancelled);
                }
            }

            initApproveBtnsNew();
            initDeclineBtnsNew();
            initDownloadBtn();
        })
        .catch(function (err) {
            console.log(err);
        });
}

function approveOrder(event) {
    event.preventDefault();

    var el = this;

    var form = el.closest("form");
    var number = el.getAttribute('data-order-number');
    var language = el.getAttribute('data-language');
    var securityString = el.getAttribute('data-securitystring');

    var data = {
        orderNumber: number,
        language: language,
        securityString: securityString
    };

    fetch(form.action, {
        method: 'POST',
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(data)
    })
        .then(function (result) {
            return result.text();
        })
        .then(function (html) {

            var target = document.querySelector("#order-details-" + number);

            target.innerHTML = html;
            target.style.display = "table-cell";

            var orderStatus = document.querySelector("#order-status-" + number);

            var statusInProgress = orderStatus.dataset.statusInprogress;

            orderStatus.innerHTML = statusInProgress;

            initApproveBtns();
            initApproveBtnsNew();
            initDeclineBtns();
            initDeclineBtnsNew();
            initDownloadBtn();
        })
        .catch(function (err) {
            console.log(err);
        });
}

function approveOrderNew(event) {
    event.preventDefault();

    var el = this;

    var form = el.closest("form");
    var number = el.getAttribute('data-order-number');
    var language = el.getAttribute('data-language');
    var securityString = el.getAttribute('data-securitystring');

    var data = {
        orderNumber: number,
        language: language,
        securityString: securityString
    };

    window.fetch(form.action, {
        method: 'POST',
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(data)
    })
        .then(function (result) {

            if (result.status != 200) {
                // TODO Error notice?
            } else {
                hideApproveButtons(number);
                hideDeclineButtons(number);

                var orderStatuses = document.getElementById("orderStatuses");

                // Set the Order Status
                var orderStatusLabels = document.querySelectorAll(".order-status-" + number);

                var statusInProgress = orderStatuses.dataset.statusInprogress;

                for (var i = 0; i < orderStatusLabels.length; i++) {
                    orderStatusLabels[i].innerHTML = "<strong>" + statusInProgress + "</strong>";
                }

                // Set the Order Icon
                var iconSvgRef = orderStatuses.dataset.iconSvgRef;

                var iconStatusInprogress = orderStatuses.dataset.iconStatusInprogress;

                var orderStatusIcons = document.querySelectorAll(".js-icon-status-" + number);

                for (var i = 0; i < orderStatusIcons.length; i++) {

                    var titleElement = orderStatusIcons[i].getElementsByTagName("title")[0];

                    titleElement.textContent = statusInProgress;

                    var useElement = orderStatusIcons[i].getElementsByTagName("use")[0];

                    useElement.setAttributeNS("http://www.w3.org/1999/xlink", 'xlink:href', iconSvgRef + "#" + iconStatusInprogress);
                }
            }

            initApproveBtnsNew();
            initDeclineBtnsNew();
            initDownloadBtn();
        })
        .catch(function (err) {
            console.log(err);
        });
}

function hideApproveButtons(orderNumber) {
    var approveBtns = document.querySelectorAll('.approve-btn-' + orderNumber);
    for (var i = 0; i < approveBtns.length; i++) {
        approveBtns[i].style.display = "none";
    }
}

function hideDeclineButtons(orderNumber) {
    var declineBtns = document.querySelectorAll('.decline-btn-' + orderNumber);
    for (var i = 0; i < declineBtns.length; i++) {
        declineBtns[i].style.display = "none";
    }
}

function initTextboxForOrderLineQuantity(orderNumber) {
    var returnQuantityTextboxes = document.querySelectorAll(".jsReturnOrderQuantityTextbox" + orderNumber);

    for (let returnQuantityTextbox of returnQuantityTextboxes) {
        returnQuantityTextbox.onchange = checkOrderLineQuantity;
    }

}

function initReturnReasonDdl(orderNumber) {
    var returnReasonDdls = document.querySelectorAll(".jsReturnReasonDdl" + orderNumber);

    for (let returnReasonDdl of returnReasonDdls) {
        returnReasonDdl.onchange = changeReturnReason;
    }
}

function checkOrderLineQuantity() {
    var el = this;

    var quantity = parseInt(el.value);

    var originalQuantity = parseInt(el.getAttribute('data-originalquantity'));

    if (quantity > originalQuantity) {
        el.value = originalQuantity;
    }
}

function initCountryDdl() {
    var countryDdls = document.querySelectorAll(".CountrySelector select");

    for (let countryDdl of countryDdls) {
        countryDdl.onchange = countryDdlOnChange;
    }
}

function countryDdlOnChange() {
    var el = this;

    if (el.selectedIndex) {
        el.setAttribute("data-selected", true);
    }
    else {
        el.setAttribute("data-selected", false);
    }
}

function initCheckboxesForOrder(orderNumber) {
    var requestRetourCheckBoxes = document.querySelectorAll(".jsReturnOrderCheckbox" + orderNumber);

    var requestRetourButton = document.querySelector('#requestreturnorderbutton-' + orderNumber);
    var extraInfoAddress = document.querySelector('#extra-info-address-' + orderNumber);
    var extraInfoContact = document.querySelector('#extra-info-contact-' + orderNumber);

    if (requestRetourCheckBoxes !== null) {
        for (var i = 0; i < requestRetourCheckBoxes.length; i++) {
            requestRetourCheckBoxes[i].addEventListener("change", function () {

                var changedCheckboxes = document.querySelectorAll(".jsReturnOrderCheckbox" + orderNumber)

                var empty = [].filter.call(changedCheckboxes, function (el) {
                    return !el.checked
                });

                if (empty.length == changedCheckboxes.length) {
                    requestRetourButton.style.display = "none";
                    extraInfoAddress.style.display = "none";
                    extraInfoContact.style.display = "none";
                }
                else {
                    requestRetourButton.style.display = "block";
                    extraInfoAddress.style.display = "table-row";
                    extraInfoContact.style.display = "table-row";

                    $.validator.unobtrusive.parse("#jsRequestReturnForm" + orderNumber);

                    requestRetourButton.onclick = requestReturnOrder;
                }

                initCountryDdl();
            });
        }
    }
}

function requestReturnOrder(event) {
    event.preventDefault();

    var el = this;

    var action = el.getAttribute('data-action');
    var orderNumber = el.getAttribute('data-order-number');
    var language = el.getAttribute('data-language');
    var securityString = el.getAttribute('data-securitystring');

    var form = document.getElementById('jsRequestReturnForm' + orderNumber);

    var formIsValid = $(form).valid();

    if (!formIsValid) {
        return;
    }

    var lineItems = [];

    var table = document.getElementById('itemsTable-' + orderNumber);

    var checkBoxes = table.getElementsByTagName("INPUT");

    if (checkBoxes.length == 0) {
        return;
    }

    for (var i = 0; i < checkBoxes.length; i++) {
        if (checkBoxes[i].type === 'checkbox' && checkBoxes[i].checked) {
            var row = checkBoxes[i].parentNode.parentNode;

            var returnReasonLabel = "";

            if (row.cells[4].children[0].children[0].value !== "") {
                returnReasonLabel = row.cells[4].children[0].children[0].options[row.cells[4].children[0].children[0].selectedIndex].text;
            }

            let lineItem = {
                "Code": row.cells[2].innerHTML,
                "Quantity": row.cells[1].children[0].children[0].value,
                "ReturnReasonLabel": returnReasonLabel,
                "ReturnReason": row.cells[4].children[1].value
            };

            lineItems.push(lineItem);
        }
    }

    var addressLine = document.getElementById("line1" + orderNumber);
    var zipCode = document.getElementById("postalCode" + orderNumber);
    var city = document.getElementById("city" + orderNumber);
    var country = document.getElementById("countryCode" + orderNumber);
    var email = document.getElementById("email" + orderNumber);
    var phone = document.getElementById("phone" + orderNumber);

    var requestReturnInfo = {
        "AddressLine": addressLine.value,
        "Zipcode": zipCode.value,
        "City": city.value,
        "Country": country.value,
        "Email": email.value,
        "Phonenumber": phone.value
    };

    var target = document.querySelector("#order-details-" + orderNumber);

    target.innerHTML = spinner;

    var data =
    {
        orderNumber: orderNumber,
        language: language,
        securityString: securityString,
        lineItems: lineItems,
        requestReturnInfo: requestReturnInfo
    };

    fetch(action, {
        method: 'POST',
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(data)
    })
        .then(function (result) {
            return result.text();
        })
        .then(function (html) {
            target = document.querySelector("#order-details-" + orderNumber);

            target.innerHTML = html;
            target.style.display = "table-cell";

            initCheckboxesForOrder(orderNumber);
            initTextboxForOrderLineQuantity(orderNumber);
            initReturnReasonDdl(orderNumber);
        })
        .catch(function (err) {
            console.log(err);
        });
}

function toggleDetails(event) {
    var el = this;

    var orderNumber = el.getAttribute('data-order');
    var language = el.getAttribute('data-language');
    var securityString = el.getAttribute('data-securitystring');

    var target = this.parentElement.querySelector("#order-details-" + orderNumber);

    if (el.querySelector('.order-row__wrapper--arrow').classList.contains('rotated')) {
        el.querySelector('.order-row__wrapper--arrow').classList.toggle('rotated');
    }

    if (target.style.display === "none") {
        target.innerHTML = spinner;
        target.style.display = "table-cell";

        window.fetch('/OrdersPage/OrderDetails?orderNumber=' + orderNumber + "&language=" + language + "&securityString=" + securityString, {
            method: 'GET',
            headers: {
                'pragma': 'no-cache',
                'cache-control': 'no-cache'
            },
        })
            .then(function (res) {
                return res.text();
            })
            .then(function (html) {
                target.innerHTML = html;
                target.style.display = "table-cell";

                if (el.querySelector('.order-row__wrapper--arrow')) {
                    el.querySelector('.order-row__wrapper--arrow').classList.toggle('rotated');
                }

                initApproveBtns();
                initDeclineBtns();
                initDownloadBtn();

                initCheckboxesForOrder(orderNumber);
                initTextboxForOrderLineQuantity(orderNumber);
                initReturnReasonDdl(orderNumber);
            })
            .catch(function (err) {
                console.log(err);
            });
    }
    else if (target.style.display === "table-cell") {
        target.style.display = "none";
    }
}

function loadMore() {
    var el = this;

    var page = document.getElementById('order-pagenumber');
    var selectedStateFilter = document.getElementById('selectedStateFilter');
    var searchTerm = document.getElementById('searchTerm');
    var link = el.dataset.url;
    var employeeurl = el.dataset.employeeurl;

    var target = document.getElementById("orderContainer");

    page.textContent = +page.textContent + 1;

    window.fetch(link + '/LoadMore?page=' + page.textContent + "&selectedStateFilter=" + selectedStateFilter?.value + "&searchTerm=" + searchTerm.value + "&language=" + el.dataset.language + "&employeeUrl=" + employeeurl, {
        method: 'GET',
        headers: {
            'pragma': 'no-cache',
            'cache-control': 'no-cache'
        },
    })
        .then(function (res) {
            return res.text();
        })
        .then(function (html) {
            target.innerHTML += html;

            window.reinit();

            //target.style.display = "table-cell";

            //if (el.querySelector('.order-row__wrapper--arrow')) {
            //    el.querySelector('.order-row__wrapper--arrow').classList.toggle('rotated');
            //}

            //initApproveBtns();
            //initDeclineBtns();
            //initDownloadBtn();

            //initCheckboxesForOrder(orderNumber);
            //initTextboxForOrderLineQuantity(orderNumber);
            //initReturnReasonDdl(orderNumber);
        })
        .catch(function (err) {
            console.log(err);
        });
}

function changeReturnReason() {
    var el = this;

    var productCode = el.getAttribute("data-productcode");
    var orderNumber = el.getAttribute("data-ordernumber");

    var orderLineReturnReason = document.querySelector("#orderLineReturnReason" + orderNumber + productCode);

    if (el.value === "Other") {

        orderLineReturnReason.style.display = "block";
    }
    else {
        orderLineReturnReason.style.display = "none";
    }
}

(function () {
    initDownloadBtn();
})();

